export default __webpack_public_path__ + "static/23-23b4968d415250b22766a4af65c88c5e.jpg";